export function downloadFiles(blobPart, filename) {
  const blob = new Blob([blobPart], { type: 'application/octet-stream;charset=UTF-8' })
  // 创建一个超链接，将文件流赋进去，然后实现这个超链接的单击事件
  const elink = document.createElement('a')
  elink.download = decodeURIComponent(filename)
  elink.style.display = 'none'
  elink.href = URL.createObjectURL(blob)
  document.body.appendChild(elink)
  elink.click()
  URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink)
}


//base64转blob并下载
export function downloadFiles2(data) {

  // atob先解码base64数据
  const raw = window.atob(data);
  // 获取解码后的字符串长度
  const rawLength = raw.length;
  // 初始化一个 8 位无符号整型数组
  const uInt8Array = new Uint8Array(rawLength);
  // 将每个解码字符转换为unicode编码再存入数组中
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  // 通过blob格式将数组转换成你想要的类型文件，第二个是类型
  const blob = new Blob([uInt8Array], { type:  'application/octet-stream;charset=UTF-8' });
  // 创建一个a标签在页面中实现下载
  const elink = document.createElement("a");
  // elink.download = data.attachName;
  elink.style.display = "none";
  elink.href = URL.createObjectURL(blob);
  document.body.appendChild(elink);
  elink.click();

}
export function downloadFiles3(url) {
  const elink = document.createElement("a");

  elink.style.display = 'none'
  elink.href = url
  elink.download = ''
  document.body.appendChild(elink)
  elink.click()
  URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink)
}
//下载---将文件地址转化为文件流，实现可自定义文件名
export function downloadFile1(url,filename) {

  fetch(url).then(res => res.blob().then(blob => {
    let a = document.createElement('a');
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }))

}



// WEBPACK FOOTER //
// ./src/comm/utils/download.js